import { useEffect, useState } from 'react';
import { mergeValues, type InputValues } from '../inputFieldValues';
import type { PublicInputField } from '../types';

/** Values of the model-specific inputs; re-seeded with defaults whenever the model changes. */
export function useModelInputValues(fields: PublicInputField[], resetKey: string) {
  const [values, setValues] = useState<InputValues>(() => mergeValues(fields, {}));

  useEffect(() => {
    setValues((current) => mergeValues(fields, current));
    // fields identity changes with the model; resetKey is the stable model identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const setValue = (key: string, value: unknown) =>
    setValues((current) => ({ ...current, [key]: value }));

  return { values, setValue };
}
